module.exports = __webpack_public_path__ + "static/media/plus-white.b2e24b2a.svg";